"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Master_1 = __importDefault(require("../../../networking/apis/Master"));
const User_1 = __importDefault(require("../../../networking/apis/User"));
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const SelectTagScreen = () => {
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [checkRegister, setCheckRegister] = (0, react_1.useState)(false);
    const [selectedTags, setSelectedTags] = (0, react_1.useState)([]);
    const [isLoading, setLoading] = (0, react_1.useState)(true);
    const [tags, setTags] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (connected) {
            Master_1.default.getHashtagList()
                .then(response => {
                setTags(response.data);
            })
                .catch(err => {
                console.log(err);
            })
                .finally(() => setLoading(false));
        }
    }, [connected]);
    const onPrimaryButtonPress = () => {
        if (checkRegister) {
            (0, rootNavigation_1.navigate)(Routes_1.default.TUTORIAL);
        }
        else {
            setLoading(true);
            const formData = new FormData();
            selectedTags.map((item, index) => {
                formData.append(`hash_tags[${index}]`, `${item}`);
            });
            User_1.default.initialSetup(formData)
                .then(() => {
                setCheckRegister(true);
            })
                .catch((error) => {
                if (error?.response?.data?.error?.message) {
                    react_native_1.Platform.OS === 'web' ?
                        alert(error.response.data.error.message)
                        :
                            react_native_1.Alert.alert('', error.response.data.error.message);
                }
            })
                .finally(() => {
                setLoading(false);
            });
        }
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: {
            backgroundColor: "#F7F7F7",
            flex: 1,
        } },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: "フォロータグ登録", styleContainer: {
                backgroundColor: Colors_1.default.white,
                zIndex: 1,
            }, rightIcon: !checkRegister && (react_1.default.createElement(CustomText_1.default, { style: {
                    fontSize: (0, scale_1.moderateScale)(12),
                    lineHeight: (0, scale_1.moderateScale)(18),
                    fontWeight: "300",
                    color: "#007AFF",
                } }, "\u3042\u3068\u3067\u884C\u3046")), onRightPress: () => {
                !checkRegister && (0, rootNavigation_1.navigate)(Routes_1.default.TUTORIAL);
            } }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.viewTitle },
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.title }, checkRegister ? "フォロータグ登録完了" : "フォロータグ登録")),
            react_1.default.createElement(CustomText_1.default, { style: {
                    fontSize: (0, scale_1.moderateScale)(15),
                    fontWeight: "300",
                    lineHeight: (0, scale_1.moderateScale)(23),
                    color: "#292A33",
                } }, checkRegister
                ? `登録お疲れ様でした。\nチュートリアルを受けてさっそくはじめてみましょう！`
                : `気になるタグを選択してください（複数選択可）。`),
            !checkRegister && (react_1.default.createElement(react_native_1.View, { style: { flex: 1 } },
                react_1.default.createElement(CustomText_1.default, { style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        fontWeight: "300",
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: "#545454",
                        marginTop: (0, scale_1.scale)(5),
                    } }, "\u203B\u6700\u592730\u500B\u307E\u3067\u8A2D\u5B9A\u53EF\u80FD\u3067\u3059\u3002"),
                react_1.default.createElement(react_native_1.View, { style: {
                        flex: 1,
                        marginTop: (0, scale_1.scale)(24),
                        width: "100%",
                    } },
                    react_1.default.createElement(react_native_1.ScrollView, { showsVerticalScrollIndicator: false },
                        react_1.default.createElement(react_native_1.View, { style: {
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: (0, scale_1.scale)(8)
                            } }, tags.map((item, index) => {
                            const isActive = selectedTags.includes(item.hash_tag_id);
                            return (react_1.default.createElement(react_native_1.TouchableOpacity, { key: index, style: isActive ? styles_1.default.tagSelect : styles_1.default.tagNonSelect, onPress: () => {
                                    if (isActive) {
                                        const newArr = selectedTags.filter((id) => id != item.hash_tag_id);
                                        setSelectedTags(newArr);
                                    }
                                    else if (selectedTags.length >= 30)
                                        return;
                                    else {
                                        setSelectedTags([...selectedTags, item.hash_tag_id]);
                                    }
                                } },
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: isActive ? styles_1.default?.textTagSelect : styles_1.default.titleTagSelect },
                                    "#",
                                    item.name)));
                        })))),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(11),
                        lineHeight: (0, scale_1.moderateScale)(19),
                        color: "#292A33",
                        marginTop: (0, scale_1.scale)(12)
                    } },
                    selectedTags?.length,
                    "/ 30\u500B\u9078\u629E"))),
            react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(32) }, fontWeight: "600", title: checkRegister ? "チュートリアルを受ける" : "フォロータグを登録", onPress: onPrimaryButtonPress })),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = SelectTagScreen;
